module.exports = __webpack_public_path__ + "img/vi.b65780fe.png";